import persist4browser from "persist4browser";

export default persist4browser({
  prefix: "sg",
  expire: "1d",
  // encrypt: true
});
